import { useCountriesGetAll } from '../../../hooks/api/createaccount';

interface DisplayCountryByIdProps {
  id: number | undefined;
}

function DisplayCountryById({ id }: DisplayCountryByIdProps) {
  const countriesGetAll = useCountriesGetAll();

  if (!id) {
    return '';
  }

  if (!countriesGetAll.data?.data) {
    return id;
  }

  return countriesGetAll.data?.data.find((country) => country.id === id)?.name;
}

export default DisplayCountryById;
